webpackJsonp([22],{

/***/ 1109:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DrawsPublic_vue__ = __webpack_require__(1259);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_145f3ba6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DrawsPublic_vue__ = __webpack_require__(1384);
function injectStyle (ssrContext) {
  __webpack_require__(1381)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-145f3ba6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DrawsPublic_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_145f3ba6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DrawsPublic_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1139:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppTabSwitcher',
  props: {
    items: {
      type: Array,
      required: true
    },
    value: {
      type: String,
      default: null
    }
  },
  computed: {
    modelValue: function modelValue() {
      return this.value;
    }
  }
});

/***/ }),

/***/ 1156:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppTabSwitcher_vue__ = __webpack_require__(1139);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6ae30f2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppTabSwitcher_vue__ = __webpack_require__(1157);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppTabSwitcher_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6ae30f2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppTabSwitcher_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-switcher"},_vm._l((_vm.items),function(item){return _c('a',{key:item.value,staticClass:"tab-switcher__tab",class:{ 'tab-switcher__tab--active': _vm.modelValue === item.value },attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.$emit('input', item.value)}}},[_vm._v("\n    "+_vm._s(item.label)+"\n  ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeading__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppTabSwitcher__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Pagination__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AppMultiselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__composables_draws_usePublicDraws__ = __webpack_require__(1383);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'DrawsPublic',
  components: {
    TabLayout: __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__["a" /* default */],
    PageHeading: __WEBPACK_IMPORTED_MODULE_2__components_PageHeading__["a" /* default */],
    AppTabSwitcher: __WEBPACK_IMPORTED_MODULE_3__components_AppTabSwitcher__["a" /* default */],
    Pagination: __WEBPACK_IMPORTED_MODULE_4__components_Pagination__["a" /* default */],
    AppMultiselect: __WEBPACK_IMPORTED_MODULE_5__components_AppMultiselect__["a" /* default */]
  },
  setup: function setup() {
    var _getCurrentInstance = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["d" /* getCurrentInstance */])(),
        proxy = _getCurrentInstance.proxy;

    var eventId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return proxy.$route.params.eventId;
    });
    var activeRound = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return Number(proxy.$route.params.round) || 1;
    });

    var _usePublicDraws = Object(__WEBPACK_IMPORTED_MODULE_6__composables_draws_usePublicDraws__["a" /* default */])(proxy),
        eventName = _usePublicDraws.eventName,
        rounds = _usePublicDraws.rounds,
        draws = _usePublicDraws.draws,
        loading = _usePublicDraws.loading,
        page = _usePublicDraws.page,
        perPage = _usePublicDraws.perPage,
        perPageOptions = _usePublicDraws.perPageOptions,
        totalPages = _usePublicDraws.totalPages,
        changePage = _usePublicDraws.changePage,
        changePerPage = _usePublicDraws.changePerPage;

    function roundLabel(roundNum, roundType) {
      if (roundType === 3) return 'Final round';
      if (roundType === 4) return 'Run-off';
      return "Round ".concat(roundNum);
    }

    var tabRounds = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return rounds.value.map(function (r) {
        return {
          value: String(r.round),
          label: roundLabel(r.round, r.round_type)
        };
      });
    });

    function selectRound(roundNum) {
      proxy.$router.push({
        path: "/draws/public/".concat(eventId.value, "/").concat(roundNum),
        query: {
          per_page: String(perPage.value)
        }
      });
    }

    return {
      eventName: eventName,
      tabRounds: tabRounds,
      activeRound: activeRound,
      draws: draws,
      page: page,
      totalPages: totalPages,
      perPage: perPage,
      perPageOptions: perPageOptions,
      changePage: changePage,
      changePerPage: changePerPage,
      loading: loading,
      selectRound: selectRound
    };
  }
}));

/***/ }),

/***/ 1381:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1382);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("1dc1f57e", content, true, {});

/***/ }),

/***/ 1382:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".draws-table.\\--public-table .draws-table__col.\\--names[data-v-145f3ba6]{justify-content:flex-start}.draws-table.\\--public-table .draws-table__col.\\--names>.draws-table__cell[data-v-145f3ba6]{width:31%;flex:0 0 31%;text-align:left}.draws-public-per-page[data-v-145f3ba6]{flex:0 0 72px}@media (max-width:402px){.draws-public-per-page[data-v-145f3ba6]{flex:1 1 0;min-width:0}}@media (max-width:575px){.draws-table__col.\\--names[data-v-145f3ba6]{flex-wrap:wrap}.draws-table__col.\\--names>.draws-table__cell[data-v-145f3ba6]{width:auto!important;flex:1 1 0;min-width:0;word-break:normal;overflow-wrap:break-word}.draws-table__col.\\--names>.draws-table__cell[data-v-145f3ba6]:nth-of-type(2){flex-basis:100%;width:100%!important}}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/views/Draws/Public/DrawsPublic.vue"],"names":[],"mappings":"AACA,yEACE,0BAA4B,CAC7B,AACD,4FACE,UAAW,AACX,aAAc,AACd,eAAiB,CAClB,AACD,wCACE,aAAe,CAChB,AACD,yBACA,wCACI,WAAY,AACZ,WAAa,CAChB,CACA,AACD,yBACA,4CACI,cAAgB,CACnB,AACD,+DACI,qBAAuB,AACvB,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,wBAA0B,CAC7B,AACD,8EACI,gBAAiB,AACjB,oBAAuB,CAC1B,CACA","file":"DrawsPublic.vue","sourcesContent":["\n.draws-table.--public-table .draws-table__col.--names[data-v-145f3ba6] {\n  justify-content: flex-start;\n}\n.draws-table.--public-table .draws-table__col.--names > .draws-table__cell[data-v-145f3ba6] {\n  width: 31%;\n  flex: 0 0 31%;\n  text-align: left;\n}\n.draws-public-per-page[data-v-145f3ba6] {\n  flex: 0 0 72px;\n}\n@media (max-width: 402px) {\n.draws-public-per-page[data-v-145f3ba6] {\n    flex: 1 1 0;\n    min-width: 0;\n}\n}\n@media (max-width: 575px) {\n.draws-table__col.--names[data-v-145f3ba6] {\n    flex-wrap: wrap;\n}\n.draws-table__col.--names > .draws-table__cell[data-v-145f3ba6] {\n    width: auto !important;\n    flex: 1 1 0;\n    min-width: 0;\n    word-break: normal;\n    overflow-wrap: break-word;\n}\n.draws-table__col.--names > .draws-table__cell[data-v-145f3ba6]:nth-of-type(2) {\n    flex-basis: 100%;\n    width: 100% !important;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1383:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = usePublicDraws;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var PER_PAGE_OPTIONS = [20, 50, 100];
function usePublicDraws(proxy) {
  var state = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return proxy.$store.state.publicDraws;
  });
  var page = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    var value = Number(proxy.$route.query.page);
    return Number.isInteger(value) && value > 0 ? value : 1;
  });
  var perPage = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    var value = Number(proxy.$route.query.per_page);
    return PER_PAGE_OPTIONS.includes(value) ? value : PER_PAGE_OPTIONS[0];
  });

  function changePage(value) {
    if (value === page.value) return;
    proxy.$router.push({
      query: _objectSpread({}, proxy.$route.query, {
        page: String(value)
      })
    });
  }

  function changePerPage(value) {
    if (value === perPage.value) return;
    proxy.$router.push({
      query: _objectSpread({}, proxy.$route.query, {
        page: '1',
        per_page: String(value)
      })
    });
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(function () {
    return proxy.$route.params.eventId;
  }, function (eventId) {
    proxy.$store.dispatch('publicDraws/fetchInfo', eventId);
  }, {
    immediate: true
  });
  Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(function () {
    return [proxy.$route.params.eventId, proxy.$route.params.round, page.value, perPage.value];
  }, function () {
    proxy.$store.dispatch('publicDraws/fetch', {
      eventId: proxy.$route.params.eventId,
      round: Number(proxy.$route.params.round) || 1,
      page: page.value,
      perPage: perPage.value
    });
  }, {
    immediate: true
  }); // A saved URL may point past the final page after runs have been removed.

  Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(function () {
    return state.value.meta;
  }, function (meta) {
    if (meta.last_page && page.value > meta.last_page) {
      proxy.$router.replace({
        query: _objectSpread({}, proxy.$route.query, {
          page: String(meta.last_page)
        })
      });
    }
  });
  return {
    eventName: Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return state.value.event.name || 'Draws';
    }),
    rounds: Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return state.value.rounds;
    }),
    draws: Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return state.value.draws;
    }),
    loading: Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return state.value.loading || state.value.infoLoading;
    }),
    totalPages: Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return state.value.meta.last_page || 1;
    }),
    page: page,
    perPage: perPage,
    perPageOptions: PER_PAGE_OPTIONS,
    changePage: changePage,
    changePerPage: changePerPage
  };
}

/***/ }),

/***/ 1384:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',{attrs:{"full-width":true}},[_c('div',{staticClass:"bg-white rounded mb-4 p-3",attrs:{"slot":"tabContent"},slot:"tabContent"},[_c('page-heading',[_vm._v(_vm._s(_vm.eventName))]),_vm._v(" "),(_vm.tabRounds.length)?_c('app-tab-switcher',{staticClass:"mb-3",attrs:{"items":_vm.tabRounds,"value":String(_vm.activeRound)},on:{"input":function($event){_vm.selectRound(Number($event))}}}):_vm._e(),_vm._v(" "),(!_vm.loading && !_vm.draws.length)?_c('p',{staticClass:"text-muted"},[_vm._v("\n      The draw for this event is not yet published. Please try again later.\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"position-relative",staticStyle:{"min-height":"200px"}},[(_vm.loading)?_c('div',{staticClass:"table-overlay"},[_c('div',{staticClass:"table-spinner"})]):_vm._e(),_vm._v(" "),(_vm.draws.length)?_c('div',{staticClass:"draws-table --public-table"},[_c('div',{staticClass:"draws-table__headers"},[_c('div',{staticClass:"draws-table__header-main"},[_c('div',{staticClass:"draws-table__row"},[_c('div',{staticClass:"draws-table__heading --runs"},[_c('strong',[_vm._v("Runs")])])])]),_vm._v(" "),_c('div',{staticClass:"draws-table__header-small"},[_c('div',{staticClass:"draws-table__row"},[_c('div',{staticClass:"draws-table__col --names"},[_c('div',{staticClass:"draws-table__cell draws-table__heading-small"},[_vm._v("Competitor")]),_vm._v(" "),_c('div',{staticClass:"draws-table__cell draws-table__heading-small"},[_vm._v("Horse")])])])])]),_vm._v(" "),_c('div',{staticClass:"draws-table__body"},_vm._l((_vm.draws),function(draw){return _c('div',{key:draw.id,staticClass:"draws-table__row"},[_c('div',{staticClass:"draws-table__col --names"},[_c('div',{staticClass:"draws-table__cell"},[_c('span',{staticClass:"row-number"},[_vm._v(_vm._s(draw.order)+". ")]),_vm._v(_vm._s(draw.rider)),(draw.rider_deleted)?_c('span',[_vm._v(" (deleted)")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"draws-table__cell"},[_vm._v(_vm._s(draw.horse)),(draw.horse_deleted)?_c('span',[_vm._v(" (deleted)")]):_vm._e()])])])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-inline justify-content-between align-items-start mt-3"},[_c('div',{staticClass:"d-flex align-items-center justify-content-center justify-content-md-start form-group mb-3 mb-md-0 col-12 col-md-auto px-0"},[_c('span',{staticClass:"mr-2"},[_vm._v("Show")]),_vm._v(" "),_c('app-multiselect',{staticClass:"draws-public-per-page",attrs:{"value":_vm.perPage,"options":_vm.perPageOptions,"searchable":false,"disabled":_vm.loading},on:{"input":_vm.changePerPage}}),_vm._v(" "),_c('span',{staticClass:"ml-2"},[_vm._v("Entries")])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.totalPages > 1),expression:"totalPages > 1"}],staticClass:"pagination-container form-group align-items-start justify-content-center mb-3 mb-md-0"},[_c('pagination',{attrs:{"page":_vm.page,"total-pages":_vm.totalPages,"disabled":_vm.loading,"on-change":_vm.changePage}})],1)])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/22.252b383f33f8575d65e7.js